export default __webpack_public_path__ + "static/media/icon-hosting.cd4e35be.svg";